<script>
	const model = require('model/model');

	module.exports = {
		data() {
			return {
				failed: false
			};
		},
		mounted() {
			let token = model.get('gcAccessToken');
			if (token) {
				model.set('localGCAccessToken', token);
				model.remove('gcAccessToken');
				window.close();
			} else {
				this.failed = true;
			}
		}
	};
</script>
<template>
	<main
		id="content"
		class="main google-token">
		<header class="main-header">
			<div class="wrapper">
				<h1 class="main-header-title">Google Authentication</h1>
			</div>
		</header>
		<section
			class="main-content wrapper"
			v-if="!failed">
			Authenticating with Google...
		</section>
		<section
			class="main-content wrapper"
			v-if="failed">
			Failed to authenticate with Google. Please close this window and refresh the page you were on.
		</section>
	</main>
</template>
